import { NgTemplateOutlet } from '@angular/common';
import { Component, input, Input, output, ViewEncapsulation } from '@angular/core';
import { QueryParamsHandling, RouterLink } from '@angular/router';
import { LoadingSpinnerComponent } from '../forms/loading-spinner/loading-spinner.component';

type ButtonVariants = 'primary' | 'secondary' | 'link' | 'link-small';

type ButtonStyleOptions = {
  variant: ButtonVariants;
  disabled: boolean;
  fill: boolean;
  pressed?: boolean;
  isLink?: boolean;
  type?: 'button' | 'submit';
  url?: string | string[];
  queryParams?: Record<string, any>;
  target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
  queryParamsHandling?: QueryParamsHandling;
  alignment?: 'left' | 'center' | 'right';
};

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [RouterLink, NgTemplateOutlet, LoadingSpinnerComponent],
  templateUrl: './button.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './button.shared.component.scss',
    './button.primary.component.scss',
    './button.secondary.component.scss',
    './button.link.component.scss',
  ],
})
export class ButtonComponent {
  dataLabel = input.required<string>();

  private readonly _initialButtonState: ButtonStyleOptions = {
    variant: 'primary',
    disabled: false,
    fill: true,
  };

  @Input() set buttonOptions(value: Partial<ButtonStyleOptions>) {
    this.inAppNavigation = !!(value.isLink && typeof value.url !== 'string');
    this._button = {
      ...this._initialButtonState,
      ...(value || {}),
    };
  }
  get buttonOptions(): ButtonStyleOptions {
    return this._button;
  }
  private _button: ButtonStyleOptions = this._initialButtonState;

  tabbable = input(true);

  loading = input(false);

  onClick = output<void>();

  onFocus = output<void>();

  inAppNavigation: boolean = true;
}
